import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const CENAttributeSearchTermHandler: Handler = (props: any) => {
    props.dispatch({
        type: "Custom/ProductListCardList/AttributeFilterSearchTerm",
        data: props.parameter.data,
    });
};

export const chain = [CENAttributeSearchTermHandler];

const cenAttributeSearchTermHandler = createHandlerChainRunnerOptionalParameter(chain, {}, "CENAttributeSearchTermHandler");
export default cenAttributeSearchTermHandler;
